export const GET_ALL_USERS_AUDITS = "GET_ALL_USERS_AUDITS";
export const CLEAR_ALL_USERS_AUDITS = "CLEAR_ALL_USERS_AUDITS";
export const GET_PROJECTS_AUDITS_IN_SEARCH = "GET_PROJECTS_AUDITS_IN_SEARCH";
export const GET_USERS_AUDITS_IN_SEARCH = "GET_USERS_AUDITS_IN_SEARCH";
